import { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { printLocationBarcode } from '../../../../store/printing/print.actions';

/**
 * Hook for location barcode printing functionality
 * @param {object} params - Parameters
 * @param {string[]} params.locationIds - The IDs of the selected locations
 * @returns {object} An object containing:
 * - {boolean} isDisabled: Indicates if printing is disabled (true if there are no location IDs or printing is in progress).
 * - {function} onPrint: Function to trigger the location barcode print action.
 */
export const usePrintLocationBarcode = ({ locationIds }) => {
  const dispatch = useDispatch();

  const isDisabled = useMemo(() => {
    return !locationIds || locationIds.length === 0;
  }, [locationIds]);

  const onPrint = useCallback(
    (printType) => {
      if (locationIds && locationIds.length > 0) {
        dispatch(printLocationBarcode(locationIds, printType));
      }
    },
    [dispatch, locationIds],
  );

  return {
    isDisabled,
    onPrint,
  };
};
